module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-1-968eaf32088e866d51b295bfb2711b26.svg";